/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { chatSessionsCreate } from "../funcs/chatSessionsCreate.js";
import { chatSessionsRevoke } from "../funcs/chatSessionsRevoke.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { CreateResponseBody } from "../models/components/createresponsebody.js";
import {
  CreateChatSessionRequest,
  CreateChatSessionSecurity,
} from "../models/operations/createchatsession.js";
import {
  RevokeChatSessionRequest,
  RevokeChatSessionSecurity,
} from "../models/operations/revokechatsession.js";
import { unwrapAsync } from "../types/fp.js";

export class ChatSessions extends ClientSDK {
  /**
   * create chatSessions
   *
   * @remarks
   * Creates a new chat session token
   */
  async create(
    request: CreateChatSessionRequest,
    security?: CreateChatSessionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CreateResponseBody> {
    return unwrapAsync(chatSessionsCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * revoke chatSessions
   *
   * @remarks
   * Revokes an existing chat session token
   */
  async revoke(
    request: RevokeChatSessionRequest,
    security?: RevokeChatSessionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(chatSessionsRevoke(
      this,
      request,
      security,
      options,
    ));
  }
}
